import { render, staticRenderFns } from "./majorPath.vue?vue&type=template&id=cd6db9c2&scoped=true"
import script from "./majorPath.vue?vue&type=script&lang=js"
export * from "./majorPath.vue?vue&type=script&lang=js"
import style0 from "./majorPath.vue?vue&type=style&index=0&id=cd6db9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6db9c2",
  null
  
)

export default component.exports